export default __webpack_public_path__ + "static/media/287.6578884a.png";